import React from 'react';
import i18n from 'i18next';

import {
  CreatableEntityButton,
} from 'web-components';

import {
  Flex,
  Text,
  icons,
} from 'web-styled';

type Option = {
  value: string
  label: string
};

type Props = {
  type: string;
  options: Array<Option>;
  readOnly?: boolean;
  onRequestAdd: { (option: Option): void };
  onRequestAddNew: { (option: Option): void };
};

const NestedWorkout = ({
  type,
  options,
  readOnly,
  onRequestAdd,
  onRequestAddNew,
}: Props) => (
  <Flex
    column
    fillSpace
    align="center"
    justify="center"
    spacing={25}
  >
    <img width={80} src={icons.shiningSun} alt="" />
    <Text color="#c1c1c1">
      {i18n.t('workout.nested.type', { type })}
    </Text>
    {!readOnly && (
      <Flex
        width="50%"
        align="center"
        justify="center"
      >
        <CreatableEntityButton
          options={options}
          buttonLabel={`Add ${type}`}
          placeholder={`Search ${type}`}
          onRequestAdd={onRequestAdd}
          onRequestAddNew={onRequestAddNew}
        />
      </Flex>
    )}
  </Flex>
);

NestedWorkout.defaultProps = {
  readOnly: false,
};

export default NestedWorkout;
